<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2009</span></div>
    </div>
    <div class="view-wrap yr2009">


<FullYearStats fullGames='15' fullCompletions='363' fullAttempts='514' fullYards='4,388' fullPct='70.6' fullTDs='34' fullINTs='11' fullYPG='292.5' fullRating='109.6'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">

      <div class="year-summary-text-flex">

      <h1 class="content-headline">"Pigs have flown...Hell has frozen over..."</h1>

      <div class="copy-paragraph">
      "...the Saints are on their way to the Super Bowl!" Jim Henderson's call at the end of the 2009 NFC Championship game in the Mercedes-Benz Superdome still echos in the minds of all Saints fans. Brees was able to help deliver the biggest care package to what many call 'the city that care forgot'.
      <br/><br/>

      Brees' yardage totals were his lowest since 2005, but he was more efficient than ever. Drew carried a passer rating of 109.6 with a better than 3-to-1 TD to INT rate, completing 70.6% of his passes on his way to an award-filled season for the ages.
      <br/><br/>

     After missing the playoffs two years in a row, the Saints came out firing, scoring 45+ points in each of their first 2 games. They would take that momentum to 13 straight wins, dropping their last three regular season games. The Saints would eventually win their final three games. The rest is Super Bowl history...
       <br/><br/>


  <VideoExternal button="Video1" vidName="9 for No. 9 - A Champions Journey - Chapter 6" vidUrl="https://youtu.be/ZPtIBzllfu8">WATCH: 9 for No. 9 - A Champions Journey - Chapter 6: XLIV</VideoExternal>
       <br/><br/>


      </div>

      <div class="copy-paragraph">
      <img :src="require('@/assets/brees-2009-slide-3.jpg')" style="width:100%;" alt="Drew Brees being congratulated by Tom and Gayle Benson after his NFC Championship victory over the Minnesota Vikings">
      <!--<img :src="require('@/assets/brees-2009-img-in-copy.jpg')" style="width:100%;">-->
      </div>

      <div class="awards-wrapper">
        <div class="awards-headline">2009 Awards</div>
        <ul>

          <li><img :src="require('@/assets/sbxliv-logo.png')" alt="Super Bowl 44 Logo"> Super Bowl XLIV MVP</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 1st Team All-Pro (SN)</li>
          <li><img :src="require('@/assets/nfl-logo.svg')" alt="NFL Logo"> 2nd Team All-Pro (AP)</li>
          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2009 Pro Bowl Starter</li>
          <li><img :src="require('@/assets/sn-logo.png')" alt="Sporting News Logo"> SN Offensive Player of the Year</li>
          <li><img :src="require('@/assets/maxwell-award.png')" alt="Maxwell Club Logo"> Bert Bell Award</li>
          <li><img :src="require('@/assets/nfl-alumni.png')" alt="NFL Alumni Logo"> NFL Alumni QB of the Year</li>
          <li><img :src="require('@/assets/101-award.png')" alt="101 Awards Logo"> Committee of 101 NFC Offensive Player of the Year</li>
          <li><img :src="require('@/assets/sn-logo.png')" alt="Sporting News Logo"> SN 100 Greatest Players (No. 18)</li>
          <li><img :src="require('@/assets/fedex-air.jpg')" alt="FedEx Logo"> FedEx Air Player of the Year</li>
          <li><img :src="require('@/assets/usa-football.jpg')" alt="USA Football Logo"> USA Football All-Fundamentals Team</li>
          
          
          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
    </div>
  </div>


 <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">2009 Top Rated Passers</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2009 Touchdown Tally"> 2009 TOUCHDOWN TALLY</h1>
</div>




</div>


<TDsByYear :tds="this.tds"></TDsByYear>



<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image1)" alt="Drew Brees in 2009 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image2)" alt="Drew Brees in 2009 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image3)" alt="Drew Brees in 2009 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image4)" alt="Drew Brees in 2009 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image5)" alt="Drew Brees in 2009 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image6)" alt="Drew Brees in 2009 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image7)" alt="Drew Brees in 2009 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/placeholder1.gif')" :data-flickity-lazyload="require('@/assets/' + image8)" alt="Drew Brees in 2009 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2008">«2008</router-link></div>
  <div class="year-pagination-section year-pagination-current">2009</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2010">2010»</router-link></div>
</div>



    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import VideoExternal from '@/components/VideoExternal.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2009',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    VideoExternal,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2009 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2009-top.jpg",
      image1: "brees-2009-slide-1.jpg",
      image2: "brees-2009-slide-2.jpg",
      image3: "brees-2009-img-in-copy.jpg",
      image4: "brees-2009-slide-4.jpg",
      image5: "brees-2009-slide-5.jpg",
      image6: "brees-2009-slide-6.jpg",
      image7: "brees-2009-slide-7.jpg",
      image8: "brees-2009-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true,
            lazyLoad: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2009;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },
   mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)

},

created() {

      

       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "#101820",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 109.6,
                  y: 292.5,
                  r: 34/1.5
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#fff",
        "borderColor": "#002C5F",
        "fill": false,
        radius: 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 99.9,
                  y: 281.3,
                  r: 33/1.5
                }
              ]
      },
      {
        "label": "Phillip Rivers",
        "backgroundColor": "#0080C6",
        "borderColor": "#FFC20E",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 104.4,
                  y: 265.9,
                  r: 28/1.5
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 103.2,
                  y: 277.1,
                  r: 30/1.5
                }
              ]
      },
      {
        "label": "Brett Favre",
        "backgroundColor": "#4F2683",
        "borderColor": "#FFC62F",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 107.2,
                  y: 262.6,
                  r: 33/1.5
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is Touchdowns)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel.toLocaleString() + ' Yards Per Game, ' + tooltipItem.xLabel.toLocaleString() + ' QB Rating, ' + rLabel*1.5 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards Per Game'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'QB Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }

    }
}
</script>

<style>

.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2009.vue